import type { ChatBadge } from '@hypevault/shared-types';

/**
 * Twitch's global badge image URLs. These IDs are stable, public, and served
 * by Twitch's CDN with no auth — same images that render in twitch.tv chat.
 *
 * We use them for ALL platforms because the badge keys in ChatMessage are
 * already normalized (broadcaster/mod/vip/sub/verified/partner). Kick and
 * YouTube use the same role concepts, so reusing Twitch's icon set gives a
 * recognizable visual without forcing per-platform badge artwork.
 *
 * Path format: /badges/v1/<uuid>/1  (1 = 18×18 px, 2 = 36×36 px, 3 = 72×72).
 */
export const TWITCH_BADGE_URL: Record<ChatBadge, string> = {
  broadcaster: 'https://static-cdn.jtvnw.net/badges/v1/5527c58c-fb7d-422d-b71b-f309dcb85cc1/2',
  mod: 'https://static-cdn.jtvnw.net/badges/v1/3267646d-33f0-4b17-b3df-f923a41db1d0/2',
  vip: 'https://static-cdn.jtvnw.net/badges/v1/b817aba4-fad8-49e2-b88a-7cc744dfa6ec/2',
  sub: 'https://static-cdn.jtvnw.net/badges/v1/5d9f2208-5dd8-11e7-8513-2ff4adfae661/2',
  verified: 'https://static-cdn.jtvnw.net/badges/v1/d12a2e27-16f6-41d0-ab77-b780518f00a3/2',
  partner: 'https://static-cdn.jtvnw.net/badges/v1/d12a2e27-16f6-41d0-ab77-b780518f00a3/2',
};

export const BADGE_LABEL: Record<ChatBadge, string> = {
  broadcaster: 'Broadcaster',
  mod: 'Moderator',
  vip: 'VIP',
  sub: 'Subscriber',
  verified: 'Verified',
  partner: 'Partner',
};
